import React, {
  useEffect,
  useState
} from "react";

import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

import {
  FaGraduationCap,
  FaArrowRight
} from "react-icons/fa";

import { useNavigate } from "react-router-dom";

const StudentTc = () => {
  const [open, setOpen] =
    useState(false);

  const [sessions, setSessions] =
    useState([]);

  const navigate =
    useNavigate();

  useEffect(() => {
    fetch(
      "https://stjosephweb.ilakshyaerp.in/api/student-tc/sessions"
    )
      .then((res) =>
        res.json()
      )
      .then((data) =>
        setSessions(
          Array.isArray(data)
            ? data
            : []
        )
      );
  }, []);

  return (
    <>
      <Header
        toggleSidebar={() =>
          setOpen(true)
        }
      />

      <Sidebar
        isOpen={open}
        close={() =>
          setOpen(false)
        }
      />

      {/* HERO */}
      <section className="bg-[#072F5F] py-16">

        <div className="max-w-7xl mx-auto px-5 text-center">

          <h1 className="text-4xl md:text-5xl font-extrabold text-white">

            STUDENT TC

          </h1>

          <p className="text-gray-200 text-lg mt-5">

            Select Academic Session
            To View Transfer Certificates

          </p>

          <div className="w-28 h-1 bg-[#D4A017] mx-auto rounded-full mt-5"></div>

        </div>

      </section>

      {/* SESSION SECTION */}
      <section className="bg-[#f7f9fc] py-16 min-h-screen">

        <div className="max-w-7xl mx-auto px-5 md:px-10">

          {/* TITLE */}
          <div className="text-center mb-16">

            <span className="text-[#D4A017] uppercase tracking-[5px] text-sm font-bold">

              Academic Records

            </span>

            <h2 className="text-4xl md:text-5xl font-extrabold text-[#072F5F] mt-4">

              Academic Sessions

            </h2>

          </div>

          {/* GRID */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">

            {sessions.length > 0 ? (
              sessions.map(
                (item) => (
                  <div
                    key={item.id}
                    onClick={() =>
                      navigate(
                        `/student-tc/session/${item.id}`
                      )
                    }
                    className="group bg-white rounded-[30px] shadow-lg hover:shadow-2xl border border-gray-100 cursor-pointer transition-all duration-500 hover:-translate-y-2 overflow-hidden"
                  >

                    {/* TOP BAR */}
                    <div className="h-2 bg-gradient-to-r from-[#072F5F] via-[#0B4F9C] to-[#D4A017]"></div>

                    {/* CONTENT */}
                    <div className="p-10 text-center">

                      {/* ICON */}
                      <div className="w-20 h-20 rounded-3xl bg-[#0B4F9C]/10 text-[#0B4F9C] flex items-center justify-center text-4xl mx-auto mb-8 group-hover:scale-110 transition-all duration-300">

                        <FaGraduationCap />

                      </div>

                      {/* SESSION */}
                      <h2 className="text-3xl font-extrabold text-[#072F5F] leading-snug">

                        {
                          item.session_name
                        }

                      </h2>

                      {/* LINE */}
                      <div className="w-16 h-1 bg-[#D4A017] rounded-full mx-auto mt-5 mb-6"></div>

                      <p className="text-gray-600 text-lg">

                        View Classes &
                        Student TC Records

                      </p>

                      {/* BUTTON */}
                      <div className="mt-8 inline-flex items-center gap-3 bg-[#0B4F9C] text-white px-6 py-3 rounded-2xl font-semibold shadow-lg group-hover:bg-[#072F5F] transition-all duration-300">

                        Explore

                        <FaArrowRight className="group-hover:translate-x-1 transition-all duration-300" />

                      </div>

                    </div>

                  </div>
                )
              )
            ) : (
              <div className="col-span-full">

                <div className="bg-white rounded-[35px] shadow-xl border border-gray-100 p-16 text-center">

                  <div className="w-20 h-20 rounded-full bg-[#0B4F9C]/10 text-[#0B4F9C] flex items-center justify-center text-3xl mx-auto mb-6">

                    <FaGraduationCap />

                  </div>

                  <h3 className="text-3xl font-extrabold text-[#072F5F]">

                    No Sessions Available

                  </h3>

                  <p className="text-gray-500 mt-4 text-lg">

                    Academic sessions will
                    appear here soon.

                  </p>

                </div>

              </div>
            )}

          </div>

        </div>

      </section>

      <Footer />
    </>
  );
};

export default StudentTc;